import { useState } from "react";
import { AiOutlineArrowRight } from "react-icons/ai";
import { Button, Col, Divider, Radio, Row, Tooltip, Typography } from "antd";
import { formatCurrency } from "../../../utils";
import { UserPlans } from "../../../constants/plans";
import { useAuth } from "../../../contexts/AuthContext";
import { IClient } from "../../../contexts/ClientsContext";
import {
  CardStyled,
  Feature,
  Info,
  Interval,
  Price,
  GrayOverlay,
} from "./styles";

interface IProps {
  userCount: number;
  selectedClient?: IClient | null;
  selectedPlan: number;
  setSelectedPlan: React.Dispatch<React.SetStateAction<number>>;
  setPaymentType: Function;
  isCancelRecurring: boolean;
  clientsWithCancelRecurring?: IClient[];
  planBought: string;
  isActive?: boolean;
  handleAction: React.MouseEventHandler<Element>;
}

export const ChoosePlanStep = ({
  isActive,
  userCount,
  planBought,
  selectedPlan,
  handleAction,
  selectedClient,
  setPaymentType,
  setSelectedPlan,
  isCancelRecurring,
  clientsWithCancelRecurring,
}: IProps) => {
  const { user } = useAuth();

  const [mostrarTip, setMostrarTip] = useState(false);

  return (
    <>
      <Typography.Title
        level={5}
        style={{ fontWeight: 600, fontSize: "15px", marginBottom: "1rem" }}
      >
        A contratação inclui:
      </Typography.Title>
      <div style={{ width: "100%", flexGrow: "1" }}>
        <Col span={24}>
          {UserPlans[0].includedFeatures.map((feature: any) => (
            <Feature className="feature" key={feature.name}>
              <span className="feature-icon">{feature.icon}</span>
              <span className="feature-text">
                {feature.name}
                {feature?.secondaryIcon}
              </span>
            </Feature>
          ))}
        </Col>
      </div>
      <Row gutter={[8, 8]} className="plan-boxes">
        {UserPlans.map((plan, i) => (
          <Col
            onMouseEnter={() => setMostrarTip(true)}
            onMouseLeave={() => setMostrarTip(false)}
            span={12}
            key={i}
          >
            <Tooltip
              placement="topLeft"
              open={
                mostrarTip &&
                plan.interval === "Mensal" &&
                !user.user.liberadaContratacao
              }
              title="Ative o concierge para contratar planos mensais"
            >
              <CardStyled
                hasConcierge={user.user.liberadaContratacao}
                checked={selectedPlan === i}
                onClick={() => {
                  setSelectedPlan(i);
                  setPaymentType(plan.interval.toLowerCase());
                }}
              >
                <Row>
                  <Interval>
                    <Radio checked={selectedPlan === i}>
                      {/* <CheckOutlined style={{ color: 'white' }} /> */}
                    </Radio>
                    PLANO {plan.interval.toUpperCase()}
                  </Interval>
                </Row>
                <Row>
                  <Price>{formatCurrency(plan.price)}</Price>
                </Row>
                <Row>
                  <Info>por mês no plano {plan.interval.toLowerCase()}</Info>
                </Row>
                {!user.user.liberadaContratacao && plan.interval !== "Anual" ? (
                  <GrayOverlay />
                ) : null}
              </CardStyled>
            </Tooltip>
          </Col>
        ))}
      </Row>
      <Divider />
      <div className="total-contratado">
        <Typography.Paragraph
          style={{ color: "var(--yellow)", marginBottom: "5px" }}
        >
          {isCancelRecurring && selectedPlan === 1
            ? "Atenção:"
            : "Total contratado:"}
        </Typography.Paragraph>
        {isCancelRecurring && selectedPlan === 1 ? (
          <>
            <Typography.Paragraph
              style={{
                color: "var(--red)",
                fontSize: "14px",
                fontWeight: "300",
              }}
            >
              Não é possível contratar novamente um plano cancelado. Contrate um
              plano anual para os clientes selecionados a seguir:
            </Typography.Paragraph>
            <ul>
              {(clientsWithCancelRecurring || []).map((client, i) => (
                <li key={i}>
                  {client.name} - CPF: {client.username}
                </li>
              ))}
            </ul>
          </>
        ) : (
          <Typography.Paragraph style={{ fontSize: "16px", fontWeight: "300" }}>
            {formatCurrency(UserPlans[selectedPlan].price * userCount)} por mês
            ({userCount} {userCount > 1 ? "usuários" : "usuário"})
          </Typography.Paragraph>
        )}
      </div>

      <Row justify="end">
        <Button
          disabled={
            (planBought && isActive) ||
            !!UserPlans[selectedPlan].free ||
            (isCancelRecurring && selectedPlan === 1)
          }
          type="primary"
          size="large"
          onClick={handleAction}
          style={{
            width: "100%",
            color: "black",
            fontWeight: "500",
            marginTop: "1rem",
          }}
        >
          {planBought &&
          isActive &&
          UserPlans[selectedPlan].type ===
            selectedClient?.userPlanInfoVelotax?.type ? (
            "PLANO SELECIONADO"
          ) : (
            <>
              PRÓXIMO{" "}
              <AiOutlineArrowRight
                style={{ transform: "translate(5px, 3px)" }}
              />
            </>
          )}
        </Button>
      </Row>
    </>
  );
};
